/**
 * @module
 *
 * @import {ImageFormat} from '../../ts/core/image';
 */

import {size} from '@acng/frontend-bounty/std/array.js';
import {floor, rand} from '@acng/frontend-bounty/std/number.js';
import {dummyImageMap, media} from '../../core/service/env.js';
import {user} from '../../user/user.js';

/**
 * Select a random image in the given format from a whitelabel mapped list.
 *
 * Default to a "default" format if the mapping is not defined for the format.
 *
 * @param {'none' | 'fsk'} reason - The reason for the fallback, e.g. "none", "fsk"
 * @param {ImageFormat} [format]
 *
 * @returns {string} The full source url of a fallback image
 */
export function   getFallbackImageUrl(reason, format) {
  //todo: check if this is needed or if the check for fsk already made at the usage of this function.
  const mapGroup = reason === 'none' ? 'none' : user.fsk < 18 ? 'underage' : 'none';
  const imageMap = dummyImageMap[mapGroup];
  const images = (format && imageMap[format]) ?? imageMap['default'];
  const image = images[floor(rand(size(images)))];

  return `${media.assets_ext}/img/dummy/${image}`;
}